export default "__VITE_ASSET__DXqjkBfv__"